import * as actionTypes from '../action-types';
import { SearchMenuType } from './searchMenu.types';
import { SearchMenuActions } from '../actions';

export const defaultState: SearchMenuType = {
  isOpen: false,
};

export function searchMenuReducer(
  state: SearchMenuType = defaultState,
  action: SearchMenuActions,
) {
  switch (action.type) {
    case actionTypes.TOGGLE_SEARCH_MENU: {
      return {
        isOpen: !state.isOpen,
      };
    }
    default: {
      return state;
    }
  }
}
